import React from "react";
import Figure from 'react-bootstrap/Figure';
import getImageByKey from './getImageByKey';
import Col from 'react-bootstrap/Col';  
import { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";




const Travel = (props) => {
    useEffect(
        () =>{
          Aos.init({ duration: 1000});
        },[]
        );
    return ( 
        <Col>

    <Figure className='mt-3'   data-aos="fade-right">

    <Figure.Image
        width={300}
        height={405}
        alt="171x180"
        src={getImageByKey(props.img)}
      />
      <h3>{props.tittle}</h3>
      <p>{props.description}</p>
     
  
    </Figure>

    

</Col>
     );
}
 
export default Travel;